import "./Header.css";
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { RiLogoutCircleRLine } from "react-icons/ri";
import axios from "axios";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { FaBars, FaRegUser } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useMyContext } from "../../components/Provider/CommonProvider";
import { toast } from "react-toastify"
import Response_Processing from "../Others/Response_Processing";
import { IconMyHome } from "../../Assets/MyIcons";
import { IoSearch, IoCloseSharp } from 'react-icons/io5';
import { CiShare1 } from "react-icons/ci";
import { useTour } from "../../components/Tour/TourProvider";
import { getBannerInfo } from '../../component/Commonmethod/bannerUtils';
import { useSelector, connect } from 'react-redux';

function Header(props) {
  const { themeSwitcher, themeMode, accessToken } = useMyContext();

  const { startTour, running, canResume } = useTour();
  const { t } = useTranslation();
  let username = localStorage.getItem("username");
  const productAccess = props?.permissionData?.userDetails?.role_name;
  const themeStyle = {
    left: `${!themeMode ? "3px" : "24px"}`,
  };
  const capitalizeFirstLetter = (str) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };

  const [showOverlay, setShowOverlay] = useState(false);

  const handleLogoutClick = async () => {
    try {
      setShowOverlay(true);

      // const access_token = localStorage.getItem("access_token");
      const role = Number(localStorage.getItem("role")); // Get role from storage or state


      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,

        Accept: "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/users/logout`,
        { headers }
      );

      if (response?.data?.status) {
        toast.success(response?.data?.message);
        localStorage.clear();

        // Redirect based on role
        if (role === 1) {
          window.location.href = "/login";
        } else if (role === 4) {
          window.location.href = "/partner";
        } else {
          window.location.href = "/"; // fallback
        }
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      localStorage.clear();

      // Redirect in error case as well
      const role = Number(localStorage.getItem("role"));
      if (role === 1) {
        window.location.href = "/login";
      } else if (role === 4) {
        window.location.href = "/partner";
      }

      toast.error(
        error?.response?.data?.message || error?.message || "Something went wrong"
      );
    } finally {
      setShowOverlay(false);
    }
  };

  // const handleLogoutClick = async () => {
  //   try {
  //     setShowOverlay(true)
  //     const access_token = localStorage.getItem("access_token");
  //     const headers = {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + access_token,
  //       Accept: "application/json",
  //     };
  //     const response = await axios.get(`${process.env.REACT_APP_Baseurl}/users/logout`, { headers: headers });
  //     if (response?.data?.status) {
  //       toast.success(response?.data?.message);
  //       localStorage.clear();
  //       window.location.href = '/login';
  //     } else {
  //       toast.error(response?.data?.message);
  //     }
  //   } catch (error) {
  //     localStorage.clear();
  //     window.location.href = '/login';
  //     toast.error(error?.response?.data?.message || error?.message || "Something went wrong");
  //   } finally {
  //     setShowOverlay(false);
  //   }
  // };

  const MyAlert = ({ message, setShowalert, apiresponsealert }) => {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
      const timeoutFunction = async () => {
        setTimeout(() => {
          props?.props?.setShowalert(false);
          setVisible(false);
        }, 6000);
      };

      timeoutFunction();
    }, [setVisible, setShowalert]);


    let color = "error";
    if (props?.props?.apiresponsealert?.status === true) {
      color = "success";
    }

    const onDismiss = () => {
      setVisible(false);
      props?.props?.setShowalert(false);
    };

    return (
      <Stack sx={{ width: "100%" }} spacing={2}>
        {visible && (
          <Alert
            severity={color}
            onClose={onDismiss}
            variant="filled"
            className="liveAlert"
          >
            <strong>
              {props?.props?.apiresponsealert.status === true
                ? props?.props?.apiresponsealert?.message
                : props?.props?.apiresponsealert?.message}
              {apiresponsealert?.message}
            </strong>
          </Alert>
        )}
      </Stack>
    );
  };

  const handleToggle = () => {
    props.toggleAction();
  };



  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".adminDropDownContainer")) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  // search option 


  const [labelList, setLabelList] = useState([]);


  const [searchTerm, setSearchTerm] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  // console.log(filteredResults, "filteredResults")
  const [showResults, setShowResults] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const navigate = useNavigate();
  const resultsRef = useRef(null);


  const [productType, setProductType] = useState('full_package');
  // const access_token = localStorage.getItem("access_token");
  const role = localStorage.getItem("role");

  const headers = {
    "Content-Type": "application/json", Authorization: "Bearer " + accessToken,

    Accept: "application/json", "Access-Control-Allow-Origin": "*",
  };



  const { infoBoxModelClose, fetchRequest } = useMyContext();
  const fetchCurrencySettingImageConfig = async () => {
    // const access_token = localStorage.getItem("access_token");

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,

      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    const combinedParams = {
      source: ["sidebar-management", "storefront-settings"]
    };

    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
      params: combinedParams,
      headers,
      data: {},
      infoBoxModelClose
    })
      .then(response => {
        if (response?.status) {
          const labels = response?.label_management || [];
          setLabelList(labels);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  useEffect(() => {
    fetchCurrencySettingImageConfig();
  }, []);


  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === '') {
      setFilteredResults([]);
      setShowResults(false);
      return;
    }
    const results = labelList.filter(item =>
      item.title &&
      item.title.toLowerCase().includes(value.toLowerCase()) &&
      item.redirection_path &&
      typeof item.redirection_path === 'string'
    );
    setFilteredResults(results);
    setShowResults(true);
    setActiveIndex(-1);
  };

  const handleClear = () => {
    setSearchTerm('');
    setFilteredResults([]);
    setShowResults(false);
    setActiveIndex(-1);
  };

  // const handleNavigate = (redirection_path) => {
  //   navigate(`/${redirection_path}`);
  //   handleClear();
  // };

  const handleNavigate = (redirection_path) => {
    // Check if redirection_path is null, undefined, or empty
    if (!redirection_path || typeof redirection_path !== 'string') {
      // console.warn('Invalid redirection path:', redirection_path);
      return;
    }
    const path = redirection_path.startsWith('/') ? redirection_path : `/${redirection_path}`;
    navigate(path);
    handleClear();
  };


  const handleKeyDown = (e) => {
    if (!showResults || filteredResults.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault(); // Prevent cursor movement in input
      setActiveIndex(prev => (prev + 1 < filteredResults.length ? prev + 1 : 0));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault(); // Prevent cursor movement in input
      setActiveIndex(prev => (prev - 1 >= 0 ? prev - 1 : filteredResults.length - 1));
    } else if (e.key === 'Enter') {
      if (activeIndex !== -1) {
        e.preventDefault(); // Prevent form submit if needed
        handleNavigate(filteredResults[activeIndex].redirection_path);
      } else if (filteredResults.length > 0) {
        handleNavigate(filteredResults[0].redirection_path);
      }
    }
  };



  useEffect(() => {
    if (resultsRef.current && activeIndex !== -1) {
      const activeItem = resultsRef.current.children[activeIndex];
      if (activeItem) {
        activeItem.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    }
  }, [activeIndex]);

  // search option 



  const { showBanner: timeBanner } = getBannerInfo();
  const maintenanceEnabled = useSelector(state => Number(state?.siteTheme?.siteTheme?.maintenance_banner_enabled) === 1);
  const showBanner = maintenanceEnabled && timeBanner;



  return (
    <>
      {props?.props ? (
        <div className="row spacing_bottom alertNotification">
          <div className="d-flex justify-content-center">
            <div id="liveAlert">
              {props?.props && props?.props?.showalert === true && (
                <MyAlert message={props?.props?.apiresponsealert?.message} />
              )}
            </div>
          </div>
        </div>
      ) : (
        {}
      )}
      {showOverlay && (<Response_Processing></Response_Processing>)}
      <header className="adminRightNavbar">
        <div className="d-flex justify-content-between align-items-center ">

          <nav className={`d-flex justify-content-between align-items-center ${showBanner ? "mt-5" : ""}`}>
            <div className="toggleButton d-flex align-items-center justify-content-center" onClick={handleToggle}  >
              <FaBars className="d-lg-none theme-bg-color-secondary" style={{ width: "25px", height: "25px" }} />{" "}
            </div>

            {/* search option */}

            {(productAccess === "All Access" || productAccess === "Super Admin") && (
              <>
                <div style={{ position: 'relative', maxWidth: '300px' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      padding: '0px 10px',
                      backgroundColor: '#fff',
                    }}
                    className="theme-bg-color-secondary"
                  >
                    <IoSearch
                      style={{ marginRight: '6px', margin: '0' }}
                      className="theme-bg-color-secondary"
                    />
                    <input
                      type="text"
                      placeholder="Search here..."
                      id="searchTerm0987"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      onKeyDown={handleKeyDown}
                      className="theme-bg-color-secondary"
                      style={{
                        flex: 1,
                        border: 'none',
                        outline: 'none',
                        padding: '8px 4px',
                      }}
                    />

                    {searchTerm && (
                      <button
                        onClick={handleClear}
                        style={{
                          background: '#fff',
                          color: '#000000',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: '16px',
                          padding: '0 0px',
                        }}
                        className="theme-bg-color-secondary"
                      >
                        <IoCloseSharp className="theme-bg-color-secondary" />
                      </button>
                    )}
                  </div>

                  {showResults && (
                    <ul
                      ref={resultsRef}
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        maxHeight: '200px',
                        overflowY: 'auto',
                        background: 'white',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        zIndex: 1000,
                        listStyle: 'none',
                        padding: 0,
                        marginTop: '4px',
                      }}
                      className="theme-bg-color"
                    >
                      {filteredResults?.length === 0 ? (
                        <li style={{ padding: '8px' }}>No results found</li>
                      ) : (
                        filteredResults?.map((item, index) => (
                          <li
                            key={item?.id}
                            id={item?.id}
                            onClick={() => handleNavigate(item?.redirection_path)} // opens in same tab
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '8px 12px',
                              cursor: 'pointer',
                              backgroundColor: activeIndex === index ? '#f0f0f0' : 'white',
                              borderBottom: '1px solid #eee',
                            }}
                            className="search-item theme-bg-color"
                          >
                            <span>{item?.title}</span>

                            <button
                              onClick={() => window.open(item?.redirection_path, "_blank")}
                              style={{
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                color: "#007bff",
                                display: "flex",
                                alignItems: "center",
                              }}
                              title="Open in new tab"
                            >
                              <CiShare1 style={{ width: "15px", height: "15px", strokeWidth: '1px', marginLeft: "6px" }} />
                            </button>
                          </li>
                        ))
                      )}
                    </ul>
                  )}
                </div>
              </>
            )}

            {/* search option */}




          </nav>
          {localStorage.getItem("is_child_partner") === "true" && localStorage.getItem("parent_partner_name") && (
            <div className="d-none d-lg-flex align-items-center me-auto ms-4 px-3 py-2 rounded-3 theme-bg-color-secondary border border-info shadow-sm animate__animated animate__fadeIn">
              <span className="text-info fw-bold small d-flex align-items-center">
                <span className="badge bg-info text-white me-2">Parent Partner</span>
                You are under {capitalizeFirstLetter(localStorage.getItem("parent_partner_name"))}
              </span>
            </div>
          )}
          <nav className={`d-flex justify-content-between align-items-center px-2 px-sm-3 ${showBanner ? "mt-5" : ""}`}>


            <div className="d-flex align-items-center gap-4 ">
              {(productAccess === "All Access" || productAccess === "Super Admin") && (
                <button className="d-flex align-items-center gap-2 px-3 py-2 rounded-3 border theme-text-color text-decoration-color home-hover-bg home-transition" onClick={startTour} id="startAdminTourBtn">
                  <span className="d-none d-md-block">{"Guide"}</span>
                </button>
              )}
              {(productAccess == "All Access" || productAccess == "Super Admin") && <Link to={`${process.env.REACT_APP_Baseurl_Frontend}`} className="d-flex align-items-center gap-2 px-3 py-2 rounded-3 border theme-text-color text-decoration-color home-hover-bg home-transition" target="_blank" rel="noreferrer" ><IconMyHome styled={{ width: "20px", height: "20px" }} /><span className="d-none d-md-block">{t("Visit Website")}</span></Link>}
              <div className={`dropdown position-relative adminDropDownContainer py-3 ${isOpen ? "open" : ""}`}>
                <button className="d-flex align-items-center px-3 py-2 bg-transparent shadow rightSideButton theme-text-color" onClick={toggleDropdown}>
                  <FaRegUser style={{ fill: "currentColor", width: "20px", height: "20px" }} />
                  <p className="mb-0 userText theme-text-color">
                    {localStorage.getItem("is_child_partner") === "true" 
                      ? `${capitalizeFirstLetter(localStorage.getItem("parent_partner_name"))} (${capitalizeFirstLetter(username)})`
                      : t(`${capitalizeFirstLetter(username)}`)
                    }
                  </p>
                </button>
                <ul className="adminSideDropDown list-unstyled theme-bg-color">
                  {localStorage.getItem("role") === "4" && (
                    <li><Link className="d-flex align-items-center px-3 py-3 theme-border-bottom-secondary theme-text-color" to="/partner-profile" onClick={() => setIsOpen(false)} >My Profile</Link></li>
                  )}
                  <li className="theme-border-bottom-secondary">
                    <div className="d-flex justify-content-between align-items-center px-3 py-3"
                      onClick={() => {
                        themeSwitcher();
                        setIsOpen(false);
                      }}
                    >
                      <p className="headerSubLink theme-text-color d-block mb-0">
                        {!themeMode ? "Light" : "Dark"}
                      </p>
                      <div className="position-relative toggleButtonTheme toggleButton-border theme-bg-color-secondary">
                        <div className="toggleCircleButton bgButton" style={themeStyle}></div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="d-flex align-items-center px-3 py-3 theme-border-bottom-secondary theme-text-color cursor-pointer"
                      onClick={() => {
                        handleLogoutClick();
                        setIsOpen(false);
                      }}
                    >
                      <RiLogoutCircleRLine className="exportIcon me-2" />
                      Logout
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

        </div>
      </header>
    </>
  );
}

const mapStateToProps = state => ({
  permissionData: state.userPermission.permissionData,
});

export default connect(mapStateToProps)(React.memo(Header))
